import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import AreaChart from '../core/AreaChart';
import { Playground } from 'docz';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "area-chart-example"
    }}>{`Area chart example`}</h1>
    <h2 {...{
      "id": "demo"
    }}>{`Demo`}</h2>
    <Playground __position={0} __code={'<AreaChart\n  color=\"#3e2723\"\n  xType=\"time\"\n  lineMarkValue={3}\n  lineMarkColor=\"#E65100\"\n  lineMakeName=\"mark\"\n  title=\"mark\"\n  toolboxTooltip={{ saveAsImage: \'Save as image\' }}\n  yComplement=\"%\"\n  dateFormat={\'yyyy-MM\'}\n  tooltipComplement=\"goals\"\n  tooltip={{ label: \'Data\', result: \'RAV\' }}\n  data={[\n    { label: \'2019-01\', result: 0.7514285714285713 },\n    { label: \'2019-02\', result: 1 },\n    { label: \'2019-03\', result: 1 },\n    { label: \'2019-04\', result: 0 },\n    { label: \'2019-05\', result: 1 },\n    { label: \'2019-06\', result: 1 },\n    { label: \'2019-07\', result: 49 },\n    { label: \'2019-08\', result: 1 },\n    { label: \'2019-09\', result: 1 },\n    { label: \'2019-10\', result: 1 },\n    { label: \'2019-11\', result: 1 },\n    { label: \'2019-12\', result: 1 },\n    { label: \'2020-01\', result: 1 },\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      AreaChart,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <AreaChart color='#3e2723' xType='time' lineMarkValue={3} lineMarkColor='#E65100' lineMakeName='mark' title='mark' toolboxTooltip={{
        saveAsImage: 'Save as image'
      }} yComplement='%' dateFormat={'yyyy-MM'} tooltipComplement='goals' tooltip={{
        label: 'Data',
        result: 'RAV'
      }} data={[{
        label: '2019-01',
        result: 0.7514285714285713
      }, {
        label: '2019-02',
        result: 1
      }, {
        label: '2019-03',
        result: 1
      }, {
        label: '2019-04',
        result: 0
      }, {
        label: '2019-05',
        result: 1
      }, {
        label: '2019-06',
        result: 1
      }, {
        label: '2019-07',
        result: 49
      }, {
        label: '2019-08',
        result: 1
      }, {
        label: '2019-09',
        result: 1
      }, {
        label: '2019-10',
        result: 1
      }, {
        label: '2019-11',
        result: 1
      }, {
        label: '2019-12',
        result: 1
      }, {
        label: '2020-01',
        result: 1
      }]} mdxType="AreaChart" />
    </Playground>
    <Playground __position={1} __code={'<AreaChart\n  color=\"#74007c\"\n  xType=\"time\"\n  yType=\"time\"\n  tooltip={{ label: \'Data\', result: \'MTBF\' }}\n  data={[\n    { label: \'2019-01-01\', result: 1.8 },\n    { label: \'2019-02-01\', result: 4.5 },\n    { label: \'2019-03-01\', result: 3 },\n    { label: \'2019-04-01\', result: 2 },\n    { label: \'2019-05-01\', result: 4 },\n    { label: \'2019-06-01\', result: 5 },\n    { label: \'2019-07-01\', result: 3 },\n    { label: \'2019-08-01\', result: 4 },\n    { label: \'2019-09-01\', result: 2 },\n    { label: \'2019-10-01\', result: 6 },\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      AreaChart,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <AreaChart color='#74007c' xType='time' yType='time' tooltip={{
        label: 'Data',
        result: 'MTBF'
      }} data={[{
        label: '2019-01-01',
        result: 1.8
      }, {
        label: '2019-02-01',
        result: 4.5
      }, {
        label: '2019-03-01',
        result: 3
      }, {
        label: '2019-04-01',
        result: 2
      }, {
        label: '2019-05-01',
        result: 4
      }, {
        label: '2019-06-01',
        result: 5
      }, {
        label: '2019-07-01',
        result: 3
      }, {
        label: '2019-08-01',
        result: 4
      }, {
        label: '2019-09-01',
        result: 2
      }, {
        label: '2019-10-01',
        result: 6
      }]} mdxType="AreaChart" />
    </Playground>
    <Playground __position={2} __code={'<AreaChart\n  xType=\"time\"\n  title=\"area chart data\"\n  toolboxTooltip={{ saveAsImage: \'saving\' }}\n  tooltip={{ label: \'Data\', result: \'O.S. em aberto\' }}\n  color=\"#E65100\"\n  data={[\n    { label: \'2019-09-01\', result: 1 },\n    { label: \'2019-09-02\', result: 4 },\n    { label: \'2019-09-03\', result: 3 },\n    { label: \'2019-09-04\', result: 2 },\n    { label: \'2019-09-05\', result: 4 },\n    { label: \'2019-09-06\', result: 5 },\n    { label: \'2019-09-07\', result: 3 },\n    { label: \'2019-09-08\', result: 7 },\n    { label: \'2019-09-09\', result: 8 },\n    { label: \'2019-09-10\', result: 9 },\n    { label: \'2019-09-11\', result: 12 },\n    { label: \'2019-09-12\', result: 22 },\n    { label: \'2019-09-13\', result: 20 },\n    { label: \'2019-09-14\', result: 32 },\n    { label: \'2019-09-15\', result: 10 },\n    { label: \'2019-09-16\', result: 15 },\n    { label: \'2019-09-17\', result: 10 },\n    { label: \'2019-09-18\', result: 31 },\n    { label: \'2019-09-19\', result: 30 },\n    { label: \'2019-09-20\', result: 30 },\n    { label: \'2019-09-21\', result: 28 },\n    { label: \'2019-09-22\', result: 25 },\n    { label: \'2019-09-23\', result: 30 },\n    { label: \'2019-09-24\', result: 17 },\n    { label: \'2019-09-25\', result: 18 },\n    { label: \'2019-09-26\', result: 19 },\n    { label: \'2019-09-27\', result: 12 },\n    { label: \'2019-09-28\', result: 22 },\n    { label: \'2019-09-29\', result: 14 },\n    { label: \'2019-09-30\', result: 15 },\n    { label: \'2019-10-01\', result: 1 },\n    { label: \'2019-10-02\', result: 4 },\n    { label: \'2019-10-03\', result: 3 },\n    { label: \'2019-10-04\', result: 2 },\n    { label: \'2019-10-05\', result: 4 },\n    { label: \'2019-10-06\', result: 5 },\n    { label: \'2019-10-07\', result: 3 },\n    { label: \'2019-10-08\', result: 7 },\n    { label: \'2019-10-09\', result: 8 },\n    { label: \'2019-10-10\', result: 9 },\n    { label: \'2019-10-11\', result: 12 },\n    { label: \'2019-10-12\', result: 22 },\n    { label: \'2019-10-13\', result: 20 },\n    { label: \'2019-10-14\', result: 32 },\n    { label: \'2019-10-15\', result: 10 },\n    { label: \'2019-10-16\', result: 15 },\n    { label: \'2019-10-17\', result: 10 },\n    { label: \'2019-10-18\', result: 31 },\n    { label: \'2019-10-19\', result: 30 },\n    { label: \'2019-10-20\', result: 30 },\n    { label: \'2019-10-21\', result: 28 },\n    { label: \'2019-10-22\', result: 25 },\n    { label: \'2019-10-23\', result: 30 },\n    { label: \'2019-10-24\', result: 17 },\n    { label: \'2019-10-25\', result: 18 },\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      AreaChart,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <AreaChart xType='time' title='area chart data' toolboxTooltip={{
        saveAsImage: 'saving'
      }} tooltip={{
        label: 'Data',
        result: 'O.S. em aberto'
      }} color='#E65100' data={[{
        label: '2019-09-01',
        result: 1
      }, {
        label: '2019-09-02',
        result: 4
      }, {
        label: '2019-09-03',
        result: 3
      }, {
        label: '2019-09-04',
        result: 2
      }, {
        label: '2019-09-05',
        result: 4
      }, {
        label: '2019-09-06',
        result: 5
      }, {
        label: '2019-09-07',
        result: 3
      }, {
        label: '2019-09-08',
        result: 7
      }, {
        label: '2019-09-09',
        result: 8
      }, {
        label: '2019-09-10',
        result: 9
      }, {
        label: '2019-09-11',
        result: 12
      }, {
        label: '2019-09-12',
        result: 22
      }, {
        label: '2019-09-13',
        result: 20
      }, {
        label: '2019-09-14',
        result: 32
      }, {
        label: '2019-09-15',
        result: 10
      }, {
        label: '2019-09-16',
        result: 15
      }, {
        label: '2019-09-17',
        result: 10
      }, {
        label: '2019-09-18',
        result: 31
      }, {
        label: '2019-09-19',
        result: 30
      }, {
        label: '2019-09-20',
        result: 30
      }, {
        label: '2019-09-21',
        result: 28
      }, {
        label: '2019-09-22',
        result: 25
      }, {
        label: '2019-09-23',
        result: 30
      }, {
        label: '2019-09-24',
        result: 17
      }, {
        label: '2019-09-25',
        result: 18
      }, {
        label: '2019-09-26',
        result: 19
      }, {
        label: '2019-09-27',
        result: 12
      }, {
        label: '2019-09-28',
        result: 22
      }, {
        label: '2019-09-29',
        result: 14
      }, {
        label: '2019-09-30',
        result: 15
      }, {
        label: '2019-10-01',
        result: 1
      }, {
        label: '2019-10-02',
        result: 4
      }, {
        label: '2019-10-03',
        result: 3
      }, {
        label: '2019-10-04',
        result: 2
      }, {
        label: '2019-10-05',
        result: 4
      }, {
        label: '2019-10-06',
        result: 5
      }, {
        label: '2019-10-07',
        result: 3
      }, {
        label: '2019-10-08',
        result: 7
      }, {
        label: '2019-10-09',
        result: 8
      }, {
        label: '2019-10-10',
        result: 9
      }, {
        label: '2019-10-11',
        result: 12
      }, {
        label: '2019-10-12',
        result: 22
      }, {
        label: '2019-10-13',
        result: 20
      }, {
        label: '2019-10-14',
        result: 32
      }, {
        label: '2019-10-15',
        result: 10
      }, {
        label: '2019-10-16',
        result: 15
      }, {
        label: '2019-10-17',
        result: 10
      }, {
        label: '2019-10-18',
        result: 31
      }, {
        label: '2019-10-19',
        result: 30
      }, {
        label: '2019-10-20',
        result: 30
      }, {
        label: '2019-10-21',
        result: 28
      }, {
        label: '2019-10-22',
        result: 25
      }, {
        label: '2019-10-23',
        result: 30
      }, {
        label: '2019-10-24',
        result: 17
      }, {
        label: '2019-10-25',
        result: 18
      }]} mdxType="AreaChart" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      